module.exports = __webpack_public_path__ + "static/media/lcy.4706b770.png";